import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { MemberRemoveInput, MemberRemovePayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { useLocale } from 'next-intl';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = MemberRemoveInput;
type TData = MemberRemovePayload;

export const useMemberRemove = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();
  useLocale;

  const graphql = gql`
    mutation memberRemove($input: MemberRemoveInput!) {
      memberRemove(input: $input) {
        success
        errors
        errorCode
        users {
          email
        }
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
